/* eslint-disable import/prefer-default-export */
import { writeToString } from '@fast-csv/format';
import download from 'downloadjs';

export const exportCsvMixin = {
  methods: {
    async exportCsvArray(headers, payload, fileName) {
      // set up the headers first
      const options = { headers };
      // write the data
      const data = await writeToString(payload, options);
      // download the data
      download(data, `${fileName}.csv`, 'text/csv');
    }
  }
}
